<template>
  <div class="page-container content-430">
    <div class="header-wrapper-430">
      <!-- 搜索模块 -->
      <SearchBlock
        :student-attance-list="true"
        @getSearchValue="handleGetSearch"
      ></SearchBlock>
      <div class="count-main">
        <div class="menu-block">
          <div v-if="showloading" class="demo-spin-container">
            <Spin fix></Spin>
          </div>
          <div style="background:#E5ECFF" class="menu-item">
            <img :src="icon1" alt="">
            <div class="menu-right">
              <div>总课时</div>
              <div>{{ countNum.totalNum }}</div>
            </div>
          </div>
          <div style="background:#DDF4FE" class="menu-item">
            <img :src="icon2" alt="">
            <div class="menu-right">
              <div>累计消课</div>
              <div>{{ countNum.cumulativeCoursesSum }}</div>
            </div>
          </div>
          <div style="background:#FEEAD6" class="menu-item">
            <img :src="icon3" alt="">
            <div class="menu-right">
              <div>已签到</div>
              <div>{{ countNum.signSum }}</div>
            </div>
          </div>
          <div style="background:#FFE0E0" class="menu-item">
            <img :src="icon4" alt="">
            <div class="menu-right">
              <div>未签到</div>
              <div>{{ countNum.notSignedSum }}</div>
            </div>
          </div>
          <div style="background:#CCFBF6" class="menu-item">
            <img :src="icon5" alt="">
            <div class="menu-right">
              <div>请假</div>
              <div>{{ countNum.leaveSum }}</div>
            </div>
          </div>
          <div style="background:#E5ECFF" class="menu-item">
            <img :src="icon1" alt="">
            <div class="menu-right">
              <div>缺勤</div>
              <div>{{ countNum.absentSum }}</div>
            </div>
          </div>
        </div>

        <div class="table-title-special-430 flex justify-content_end">
          <!-- 头部搜索框 end  -->
          <div class="ex-btn">
            <Button type="primary" @click="handleExport">导出Excel</Button>
          </div>
        </div>
      </div>
      <!-- 表格内容 -->
      <div class="table askleave-table">
        <Table
          border
          stripe
          :max-height="tableHeight"
          :columns="askLeaveColumn"
          :loading="loadingAttendanceData"
          :data="attendanceData"
        >
          <template slot="schoolName" slot-scope="{ row }">
            <TablePoptip :content="row.schoolName"> </TablePoptip>
          </template>
          <template slot="classroomName" slot-scope="{ row }">
            <TablePoptip :content="row.classroomName"> </TablePoptip>
          </template>
          <template slot="productName" slot-scope="{ row }">
            <TablePoptip :content="row.productName"> </TablePoptip>
          </template>
          <template slot="orgName" slot-scope="{ row }">
            <TablePoptip :content="row.orgName"> </TablePoptip>
          </template>
          <template slot="classType" slot-scope="{ row }">
            <span>{{
              row.classType === null ? '--' : classTypeList[row.classType]
            }}</span>
          </template>
          <template slot="studentSts" slot-scope="{ row }">
            <span :class="+row.studentSts === 0 ? 'status-red' : ''">{{
              row.studentSts === null ? '--' : stuStatusObj[row.studentSts]
            }}</span>
          </template>
          <template slot="classDateBegin" slot-scope="{ row }">
            <span>{{ row.classDateBegin | classDateBeginShow }}</span>
          </template>
          <template slot="action" slot-scope="{ row }">
            <div>
              <span
                class="click-btn-430"
                @click="handleToAttendanceDetails(row)"
              >明细</span>
              <span
                class="click-btn-430"
                @click="handleOpenOrderDrawer(row)"
              >查看订单考勤</span>
            </div>
          </template>
        </Table>
        <Page
          :total="pageInfo.total"
          show-total
          show-sizer
          show-elevator
          :current="pageInfo.pageNum"
          class="page-right"
          @on-change="handlePageChange"
          @on-page-size-change="handlePageSize"
        ></Page>
      </div>
      <!-- 下载的进度弹窗 -->
      <Modal
        v-model="percentModalShow"
        title="正在导出"
        :mask-closable="false"
        @on-cancel="handleCancelDownLoad"
      >
        <Progress :percent="downLoadPersent" :stroke-width="5"></Progress>
        正在导出表格，请给我一些时间，请不要关闭当前页面！
        <div slot="footer">
          <Button @click="handleCancelDownLoad">取消</Button>
        </div>
      </Modal>
      <OrderAttandanceDrawer
        ref="orderAttandanceDrawer"
        :stu-id="selectStuId"
        :order-id="selectOrderId"
        :classroom-id="selectClassroomId"
      ></OrderAttandanceDrawer>
      <DetailsDrawer ref="detailsDrawerRef"> </DetailsDrawer>
    </div>
  </div></template>
<script>
import {
  tableColumnsWidth,
  key,
  slot,
  renderFn
} from '@/assets/js/resetTableStyle';
import axios from 'axios';
import SearchBlock from '../assets/components/SearchBlock.vue';
import OrderAttandanceDrawer from '../assets/components/OrderAttandanceDrawer.vue';
import eduCenter from '@/request/eduCenter/index.js';
import { mapGetters, mapMutations, mapState } from 'vuex';
import { downLoadByBlob } from '@/pages/assetsModules/common.js';
import { studentStsEnumList, changeDictionaries } from '@/utils/dictionary.js';
import { getUserIp } from '@/utils/utils.js';
import cateringAdmin from '@/request/cateringAdmin/index.js';
import commonApi from '@/request/common/index.js';
import mixinTableHeight from '@/mixins/mixinTableHeight';
import DetailsDrawer from './components/DetailsDrawer.vue';
export default {
  name: 'EduCenterStudentAttanceIndex',
  components: {
    SearchBlock,
    OrderAttandanceDrawer,
    DetailsDrawer
  },
  filters: {
    classDateBeginShow(classDateBegin) {
      if (classDateBegin) {
        return classDateBegin.split(' ')[0];
      } else {
        return '--';
      }
    }
  },
  mixins: [mixinTableHeight],
  beforeRouteLeave(to, from, next) {
    this.PUSH_CACHEROUTE('EduCenterStudentAttanceIndex');
    next();
  },
  data() {
    return {
      askLeaveColumn: [
        slot('学校', 'schoolName', tableColumnsWidth.type6, { fixed: 'left' }),
        key('学生姓名', 'studentName', tableColumnsWidth.type2, { fixed: 'left' }),
        key('年级班级', 'gradeClassName', tableColumnsWidth.type9, { fixed: 'left' }),
        key('学期', 'termName', tableColumnsWidth.type4),
        key('班级ID', 'classroomId', tableColumnsWidth.type4),
        slot('课程班级名称', 'classroomName', tableColumnsWidth.type6),
        slot('课程商品名称', 'productName', tableColumnsWidth.type6),
        slot('课程分类', 'classType', tableColumnsWidth.type2),
        key('商品分类', 'courseTypeName', tableColumnsWidth.type8),
        slot('提供方', 'orgName', tableColumnsWidth.type6),
        key('上课时间', 'timeDesc', tableColumnsWidth.type4, {
          render: (h, params) => {
            return renderFn(h, params);
          }
        }),
        slot('开课日期', 'classDateBegin', tableColumnsWidth.type9),
        key('总课时', 'classroomTotal', tableColumnsWidth.type2, {
          align: 'center'
        }),
        {
          key: 'cumulativeCoursesSum',

          width: tableColumnsWidth.type9,
          align: 'center',

          renderHeader: (h, params) => {
            return h(
              'Tooltip',
              { props: { placement: 'top', transfer: true, 'max-width': '300' }}, // 提示组件的属性
              [
                h('span', [
                  h('span', '累计消课'), // 列名
                  h('Icon', { props: { type: 'ios-alert-outline' }}) // 问号图标
                ]),
                h(
                  'span',
                  {
                    slot: 'content'
                  },
                  '累计消课 = 总课时数（学期/月） -  已退款课时（学期/月）-  未开课节次（学期/月） -  请假状态（学期/月,已通过，未退款）'
                ) // 提示内容
              ]
            );
          }
        },
        // key('累计消课', 'cumulativeCoursesSum', tableColumnsWidth.type3),
        key('已签到', 'signSum', tableColumnsWidth.type2, {
          align: 'center'
        }),
        key('未签到', 'notSignedSum', tableColumnsWidth.type2, {
          align: 'center'
        }),
        key('请假', 'leaveSum', tableColumnsWidth.type2, {
          align: 'center'
        }),
        key('缺勤', 'absentSum', tableColumnsWidth.type2, {
          align: 'center'
        }),
        slot('学生状态', 'studentSts', tableColumnsWidth.type2, {
          align: 'center'
        }), // 0-离班 1-在读
        slot('操作', 'action', tableColumnsWidth.action, { fixed: 'right' })
      ],
      loadingAttendanceData: false, // 是否在加载列表
      attendanceData: [], // 请假数据
      classTypeList: [
        '--',
        '素质课程',
        '托管课程'
      ], // 课班类型 1-课程 2-托管
      pageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      }, // 请假列表分页信息
      searchData: {}, // 从搜索框组件拿到的搜索入参
      source: null,
      percentModalShow: false, //
      downLoadPersent: 0,
      percentInterVal: null,
      portOrg: -1,
      stuStatusObj: changeDictionaries(studentStsEnumList),
      activeInNums: 0, // keepAlive时候，是否首次执行activated生命周期 1为首次，大于1就不是首次进入
      downloadUrl: '', // 下载地址
      downloadToken: '',
      userIp: '', // 用户ip
      selectOrderId: '', // 选中的订单id
      selectClassroomId: '',
      selectStuId: '',
      countNum: {
        totalNum: 0, // 考勤总数
        cumulativeCoursesSum: 0, // 消课数
        signSum: 0, // 签到数
        notSignedSum: 0, // 未签到数
        leaveSum: 0, // 请假数
        absentSum: 0 // 缺勤数
      },
      showloading: false,
      icon1: require('@/assets/img/analysis/icon_number_of_schools@2x.png'),
      icon2: require('@/assets/img/analysis/icon_communication_and_collaboration_ability@2x.png'),
      icon3: require('@/assets/img/analysis/icon_job_responsibility@2x.png'),
      icon4: require('@/assets/img/analysis/icon_teaching_work@2x.png'),
      icon5: require('@/assets/img/analysis/icon_communication_and_collaboration_ability@2x.png')

    };
  },
  computed: {
    ...mapState(['cacheRoute']),
    ...mapGetters(['theUserIdentity', 'routeTitle'])
  },
  activated() {
    this.getStudentAtendanceList();
  },

  mounted() {
    this.getUserIpAddress();
    this.portOrg = Number(localStorage.getItem('portOrg'));
    // if (this.portOrg !== 2) {
    //   this.getStudentAtendanceList();
    // }
  },
  methods: {
    ...mapMutations(['SET_CACHEROUTE', 'PUSH_CACHEROUTE']),
    async getTotalNum(paramsData) {
      this.showloading = true;
      try {
        const res = await eduCenter.getStatisticSchStuSignApi(paramsData);
        if (res.status === 200) {
          Object.keys(res.message).forEach(item => {
            this.countNum[item] = res.message[item] === null ? '-' : res.message[item];
          });
        }
      } finally {
        this.showloading = false;
      }
    },
    // 获取用户IP
    async getUserIpAddress() {
      commonApi.getIpAddr().then(res => {
        this.userIp = res.message;
      });
      //  this.userIp = getUserIp();
    },
    // 下载token
    async getDownloadtoken(fileId) {
      const params = {
        fileId: [fileId],
        type: 2
      };
      const res = await cateringAdmin.getDownloadtoken(params);
      if (res.status === 200) {
        this.downloadUrl = res.message.downUrl;
        this.downloadToken = res.message.token;
      }
    },
    // 获取学生考勤列表
    async getStudentAtendanceList() {
      const params = {
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize
      };
      const paramsData = Object.assign({}, this.searchData, params);
      paramsData.schId = paramsData.schoolId ? paramsData.schoolId : null;
      // 学校id必传
      if (!paramsData.schoolId) {
        return null;
      }
      this.getTotalNum(paramsData);
      try {
        this.loadingAttendanceData = true;
        const res = await eduCenter.getStudentAttendanceListApi(paramsData);
        if (res.status === 200) {
          this.attendanceData = res.message.list;
          this.pageInfo.total = Number(res.message.total);
        } else {
          this.attendanceData = [];
          this.pageInfo.total = 0;
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loadingAttendanceData = false;
      }
    },
    handlePageChange(page) {
      this.pageInfo.pageNum = page;
      this.getStudentAtendanceList();
    },
    handlePageSize(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.pageInfo.pageNum === 1 && this.getStudentAtendanceList();
    },
    // 去到考勤明细页面
    handleToAttendanceDetails(row) {
      this.$refs.detailsDrawerRef.handleShow({ classroomId: row.classroomId, stuId: row.signPersonId, payOrderId: row.payOrderId, studentName: row.studentName, studentSts: row.studentSts });
    },
    // 获取要搜索的入参
    handleGetSearch(searchValue) {
      this.pageInfo.pageNum = 1;
      this.searchData = searchValue;
      this.getStudentAtendanceList();
    },
    // 重置搜索
    initSearch(pageNum = 1) {
      this.pageInfo.pageNum = pageNum;
      this.getStudentAtendanceList();
    },
    // 导出的时候需要选择学校才能导出
    handleExport() {
      if (!this.searchData['schoolId'] && this.theUserIdentity !== 'school') {
        this.$Message.warning('请选择学校');
        return null;
      }
      this.handleExSubmit();
    },
    // 取消导出
    handleCancelDownLoad() {
      this.percentModalShow = false;
    },
    // 导出进度条模态框提示
    percentShowFun() {
      this.downLoadPersent += 20;
      if (this.downLoadPersent >= 80) {
        clearInterval(this.percentInterVal);
      }
    },
    percentShow() {
      this.downLoadPersent = 0;
      this.percentInterVal = setInterval(this.percentShowFun, 500);
    },
    // 获取任务Id
    getTaskId(gradeId, classIds, pageSize) {
      return new Promise(async(resolve, reject) => {
        try {
          const params = {
            pageNum: 1,
            pageSize: this.pageInfo.total,
            addr: this.userIp
          };
          const paramsData = { ...this.searchData, ...params };
          paramsData.schId = paramsData.schoolId ? paramsData.schoolId : null;
          const res = await eduCenter.getStudentAttendanceTaskIdApi(paramsData);
          if (res.status === 200) {
            resolve(res.message);
          } else {
            reject(res.message);
          }
        } catch (err) {
          reject(err);
        }
      });
    },
    // 导出弹窗确定
    async handleExSubmit() {
      const taskId = await this.getTaskId();
      try {
        var source = new EventSource(`${process.env.VUE_APP_EVENT_SOURCE}/sse/subscribe?id=${taskId}`);
        this.percentShow();
        this.percentModalShow = true;
        setTimeout(async() => {
          const params = {
            pageNum: 1,
            pageSize: this.pageInfo.total,
            addr: this.userIp
          };
          const paramsData = Object.assign({}, this.searchData, params);
          paramsData.schId = paramsData.schoolId ? paramsData.schoolId : null;
          const res = await eduCenter.studentAttanceExportApi(paramsData);
        }, 3000);
        // 回调
        source.onopen = event => {
          console.log(event, '通道打开=====');
        };
        source.onmessage = async event => {
          console.log('event.data', event.data);
          // this.tipsIndex = Math.round(Math.random());
          const { resultContent, taskStatus } = JSON.parse(event.data);
          //  0 待处理 1 处理中 2处理成功 9处理异常
          if (taskStatus === 2) {
            this.$Message.success('导出成功');
            clearInterval(this.percentInterVal);
            this.downLoadPersent = 100;
            setTimeout(() => {
              this.percentModalShow = false;
              this.showSelectExportModal = false;
            }, 500);
            const infoData = JSON.parse(resultContent)[0];
            const { fileId, name } = infoData;
            // await this.getDownloadtoken();
            // downloadReport(this.downloadUrl, { fileId, token: this.downloadToken });
            // return;
            const downloadElement = document.createElement('a');
            await this.getDownloadtoken(fileId);
            const href = `${this.downloadUrl}?fileId=${fileId}&token=${this.downloadToken}`;
            downloadElement.style.display = 'none';
            downloadElement.href = href;
            downloadElement.download = name; // 下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); // 点击下载
            document.body.removeChild(downloadElement); // 下载完成移除元素
            source.close();
          }
          if (taskStatus === 9) {
            clearInterval(this.percentInterVal);
            this.downLoadPersent = 60;
            setTimeout(() => {
              this.showSelectExportModal = false;
            }, 500);
            this.$Message.error('导出失败');
          }
        };
      } catch (err) {
        clearInterval(this.percentInterVal);
        this.percent = 60;
        setTimeout(() => {
          this.showSelectExportModal = false;
        }, 500);
        this.$Message.error('导出失败');
      }
    },
    handleOpenOrderDrawer(row) {
      const { payOrderId, classroomId, signPersonId } = row;
      this.selectOrderId = payOrderId;
      this.selectClassroomId = classroomId;
      this.selectStuId = signPersonId;
      this.$nextTick(() => {
        this.$refs.orderAttandanceDrawer.open();
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.status-red {
  color: red;
}
.class-search-box {
  background: rgba(0, 0, 0, 0.03);
  border-radius: 4px;
  padding: 16px;
}
.askleave-table {
  /deep/.ivu-table-wrapper {
    overflow: visible;
  }
}
.page-right {
  text-align: right;
  margin-top: 16px;
}
.time-line-courselist {
  line-height: 24px;
  padding: 8px 0;
}
.cancel-box {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}
.askleave-table {
  /deep/.ivu-table-fixed-shadow {
    height: auto !important;
  }
}
.count-main {
  border-radius: 8px;
  border: 1px solid #eee;
  padding: 18px;
  width: 100%;
  margin: 12px 0;
}
.menu-block{
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  .menu-item{
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    padding: 16px 0;
    box-sizing: border-box;
    flex: 1;
    img{
      width:50px ;
      height: 46px;
      margin-right: 4px;
    }
    .menu-right{
      div:nth-of-type(1){
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 12px;
        line-height: 17px;
        color: #222222;
        letter-spacing: 0;
      }
      div:nth-of-type(2){
        font-family: AlibabaPuHuiTi_2_75_SNaNpxiBold;
        font-weight: 600;
        font-size: 20px;
        line-height: 33px;
        color: #222222;
        letter-spacing: 0;
      }
    }
  }
  .menu-item+.menu-item{
    margin-left:10px ;
  }
}

</style>
